module.exports = __webpack_public_path__ + "static/media/bank.b699f250.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/bank.svg
// module id = 804
// module chunks = 0